import { useEffect, useState } from "react";

interface PhotoDisplayInterface {
	photoName: string;
}

function PhotoDisplay ({photoName}: PhotoDisplayInterface) {
	const [photoURL, setPhotoURL] = useState("")

	useEffect(() => {
		async function GetPhoto() {
			setPhotoURL(process.env.REACT_APP_API+"/api/photo/" + photoName)
		}

		if (photoName) {
			GetPhoto()
		} else {
			setPhotoURL("")
		}

	}, [photoName, photoURL])

	if (photoName !== "") {
		return (
			<div><img src={photoURL} style={{ maxWidth: '200px', marginTop: '10px' }} /></div>
		)
	} else {
		return (<div></div>)
	}
}

export default PhotoDisplay;
